import './related-resources.scss';

const RelatedResourcesComponent = {
  els: null,
  referenceMap: {},
  slideDuration: 5000,

  init() {
    this.els = document.querySelectorAll('[related-resources]');
    this.els.forEach((reference, ind) => {
      this.initReference(reference, ind, null);
    });
  },

  initReference(ref) {
    let reference = this.getReference(ref);

    reference.viewAllBtn.forEach((btn) => {
      btn.addEventListener('click', () => {
        this.showAll(reference);
        btn.parentNode.style.display = 'none';
      });
    });
  },

  getReference(reference) {
    return {
      el: reference,
      allResources: reference.querySelectorAll('.resource__item'),
      viewAllBtn: reference.querySelectorAll('.button__view-all')
    }
  },

  showAll(reference) {
    reference.el.classList.add('showing-all');
    reference.allResources.forEach((item) => {
      item.style.display = 'block';
    });
  }
};

export default RelatedResourcesComponent;